import api from '../config/axios-conf';

export const getCommissions = () =>
    api.get('/services/commissionAll');

export const getCommission = (id) =>
    api.get(`/services/commission/${id}`);

export const createCommission = (data) =>
    api.post('/services/commission', data);

export const updateCommission = (id, data) =>
    api.put(`/services/commission/${id}`, data);

export const deleteCommission = (id) =>
    api.delete(`/services/commission/${id}`);
